import _get from 'lodash/get';
var styles = function styles(theme) {
  return {
    acceptedCards: {
      display: 'flex',
      '& img': {
        display: 'block !important',
        width: '32px !important',
        height: '32px !important',
        marginRight: '16px !important',
        '&:last-child': {
          marginRight: '0 !important'
        }
      }
    }
  };
};
export default styles;